import type { IconSvgObject } from './types';

const Contact01Icon: IconSvgObject = [
  ["rect", { x: "4", y: "2", width: "17.5", height: "20", rx: "4", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.59 13.7408C9.96125 14.162 8.31261 15.0221 9.31674 16.0983C9.80725 16.624 10.3536 17 11.0404 17H14.9596C15.6464 17 16.1928 16.624 16.6833 16.0983C17.6874 15.0221 16.0388 14.162 15.41 13.7408C13.9355 12.7531 12.0645 12.7531 10.59 13.7408Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 9C15 10.1046 14.1046 11 13 11C11.8954 11 11 10.1046 11 9C11 7.89543 11.8954 7 13 7C14.1046 7 15 7.89543 15 9Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 6L2.5 6M5 12L2.5 12M5 18H2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Contact01Icon;
